/**
 * Verification risk indicator codes and their mappings
 * These codes are returned from the verification service and indicate
 * specific data points that couldn't be verified
 */

export const maxVerificationAttempts = 2;

// Business verification codes
export enum BusinessVerificationCode {
  BUSINESS_NAME = '19', // Unable to verify business name on business records
  BUSINESS_ADDRESS = '20', // Unable to verify business address on business records.
  BUSINESS_ADDRESS_VACANT = '27', // The input business address is a vacant address
  BUSINESS_TIN_INVALID = '45', // The input business TIN is potentially invalid
}

// User verification codes
export enum UserVerificationCode {
  ADDRESS_TRANSIENT = '14', // The input address is a transient commercial or institutional address
  ADDRESS = '25', // Unable to verify address
  SSN_TIN = '26', // Unable to verify SSN/TIN
  DATE_OF_BIRTH = '28', // Unable to verify date-of-birth
  LAST_NAME = '37', // Unable to verify last name
  FIRST_NAME = '48', // Unable to verify first name
}
